import { DELETE_LOT } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case DELETE_LOT.LOAD:
      return {
        ...state,
        loading: true,
      };
    case DELETE_LOT.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case DELETE_LOT.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
